import { PALETTE, FONT_BODY, FONT_MONO } from "@/components/cobrain/tokens";

/* Self-select strip that routes a visitor to the right service lane
   instead of leaving them to read three cards and guess. */

export type LaneId = "audit" | "build" | "run";

export const LANES: {
  id: LaneId; q: string; maps: string; sub: string;
  closeTitle: string; closeSub: string; sticky: string; context: string;
}[] = [
  { id: "audit", q: "I don't know where to start", maps: "01",
    sub: "Start with the audit. We map the operation and rank the fixes by what pays back first.",
    closeTitle: "Let's find the money first.",
    closeSub: "Fifteen minutes with the person who'd build it. We'll find where the hours go, and say plainly which of it is worth automating.",
    sticky: "Get the audit",
    context: "Lane: not sure where to start (audit)" },
  { id: "build", q: "I know what I want built", maps: "02",
    sub: "Skip to a build. Bring the workflow, we scope it on the call and ship the first one inside a week.",
    closeTitle: "Bring the workflow. We'll scope it.",
    closeSub: "Describe what you want built. We'll tell you how it gets wired into your tools, and how fast it ships.",
    sticky: "Scope the build",
    context: "Lane: knows what to build (build & deploy)" },
  { id: "run", q: "I need someone to run it", maps: "03",
    sub: "Train or staff. We teach your ops person to run it — or put a trained operator in until you're ready.",
    closeTitle: "You don't have to run it yourself.",
    closeSub: "We'll work out whether training your person or putting one of ours in the seat is the faster route.",
    sticky: "Talk about staffing",
    context: "Lane: needs someone to run it (train or staff)" },
];

export function LaneChooser({ value, onChange }: { value: LaneId | null; onChange: (id: LaneId | null) => void }) {
  return (
    <div style={{ display: "grid", gap: 12, marginBottom: 28 }}>
      <span style={{
        fontFamily: FONT_MONO, fontSize: 10.5, letterSpacing: "0.14em",
        textTransform: "uppercase", color: PALETTE.muted, fontWeight: 700,
      }}>
        Which one are you?
      </span>
      <div role="group" aria-label="Choose the lane that fits you" className="svc-lane-row" style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
        {LANES.map((l) => {
          const on = value === l.id;
          return (
            <button
              key={l.id}
              type="button"
              aria-pressed={on}
              onClick={() => onChange(on ? null : l.id)}
              style={{
                flex: "1 1 220px", textAlign: "left", cursor: "pointer",
                minHeight: 48, padding: "12px 16px", borderRadius: 999,
                fontFamily: FONT_BODY, fontSize: 14.5, fontWeight: 600,
                color: on ? "#fff" : PALETTE.ink2,
                background: on ? PALETTE.amber : PALETTE.card,
                border: `1px solid ${on ? PALETTE.amber : PALETTE.line}`,
                transition: "background 180ms ease, color 180ms ease, border-color 180ms ease",
              }}
            >
              {l.q}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default LaneChooser;
